<template>
    <div>
      <div class="cc-prices cc-theme__rounding" v-if="roundingSK">
        <div class="cc-price-label">{{ translations['Rounding according to law'] }}</div>
        <div class="cc-price text-right">{{ formattedRounding }}</div>
      </div>
      <div class="cc-prices cc-theme__rounding" v-if="rounding">
        <div class="cc-price-label">{{ translations['Rounding'] }}</div>
        <div class="cc-price text-right">{{ formattedRounding }}</div>
      </div>
      <div class="cc-prices" v-if="useVat && vies !== 'vies_valid'">
          <div class="cc-price-label cc-price-label--total">{{ translations['Total price tax included'] }}</div>
          <div class="cc-price cc-price--total">{{ summary.formattedPrices.total_price_tax_included }}</div>
      </div>
      <div class="cc-prices" v-if="useVat && vies === 'vies_valid'">
          <div class="cc-price-label cc-price-label--total">{{ translations['Total price tax excluded'] }}</div>
          <div class="cc-price cc-price--total">{{ summary.formattedPrices.total_price_tax_included }}</div>
      </div>
      <div class="cc-prices" v-if="!useVat">
        <div class="cc-price-label cc-price-label--total">{{ translations['Total price tax excluded'] }}</div>
        <div class="cc-price cc-price--total">{{ summary.formattedPrices.total_price_tax_excluded }}</div>
      </div>
      <div class="cc-prices cc-prices--additional-price" v-if="!useVat">
        <div class="cc-price-label cc-price-label--total">{{ translations['Total price tax included'] }}</div>
        <div class="cc-price cc-price--total">{{ summary.formattedPrices.total_price_tax_included }}</div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                summary: state => state.summary,
                useVat: state => state.config.use_vat,
                vies: state => state.user.invoiceAddress.taxIdentificationNumberState,
                config: state => state.config,
                rounding: state => state.rounding,
                roundingSK: state => state.roundingSK,
                formattedRounding: state => state.formattedRounding,
            }),
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/prices";
    .cc-prices.cc-theme__rounding {
      border-top: 1px solid #d4d8d9;
      border-bottom: none;
      .cc-price-label {
        width: 80%;
      }
    }
</style>
